<template>
  <div>
    <!-- <div class="flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Games</h2>
    </div> -->
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="intro-y col-span-12">
        <div class="grid grid-cols-12 gap-5 mt-5 pt-5 border-t border-theme-5">
          <a
            href="javascript:;"
            class="intro-y block col-span-12 sm:col-span-4 xxl:col-span-3"
            @click="enterGame(1358)"
          >
            <div class="box rounded-md">
              <div class="flex-none relative block">
                <div class="pos-image__preview">
                  <img
                    alt="Midone Tailwind HTML Admin Template"
                    src="@/assets/images/evo.jpg"
                  />
                </div>
              </div>
              <div class="block font-medium text-center truncate mt-3">Evo Lobby</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Toastify from "toastify-js";
export default {
  data() {
    return {
      games: [],
    };
  },
  mounted() {
    //this.getGames();
     // 如果页面加载时是可见的，立即获取余额
     if (document.visibilityState === "visible") {
      this.getBalance();
    }

    // 监听页面可见性变化
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy() {
    // 移除事件监听器，防止内存泄漏
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
 
  },
  methods: {
    getGames() {
      let self = this;
      axios
        .get("/api/game/games", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        })
        .then((res) => {
            console.log(res)
          self.games = res.data.data.simpleGameList;
        })
        .catch(function (error) {
          self.handleError(error);
        });
    },

    enterGame(gameId) {
      let self = this;
        axios
            .post("/api/game/getEvoGame", {
              gameId: gameId
            }, {
            headers:{
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
            })
            .then((res) => {
              window.open(res.data.link, '_blank');
            })
            .catch(function (error) {
            self.handleError(error);
            });
    },

    getBalance() {
      let self = this;
        axios
          .get("/api/game/getUser", {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          })
          .then((res) => {
            if (res.data.status == "error") {
              self.handleError(res);
            } else {
              self.$store.dispatch("main/setUser", res.data.user);
            }
          })
          .catch(function (error) {
            self.handleError(error);
          });
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        // 页面可见时调用 getBalance 方法
        this.getBalance();
      }
    },
    handleError(res) {
  // 确保响应对象存在并检查错误
  if (
    (res.data?.status === "error" && res.data?.message === "Token expired") ||
    res.response?.status === 401
  ) {
    // 调用 store 中的 logout 动作并重定向到首页
    this.$store.dispatch("main/logout").then(() => {
      // 防止重复导航到当前路径
        this.$router.push({ path: "/login" });
    });
  }
}
  },
};
</script>
